import {
  ExerciseMetric,
  ExerciseMetricDisplayMetadata,
  ExerciseMetricDisplayMetadataSystem,
  ExerciseRepetition,
  OutputExercise,
  Variants,
} from "./output-exercise";
import { CustomExercise } from "./custom-exercise";

export { Variants };

export type {
  ExerciseMetric,
  ExerciseRepetition,
  OutputExercise,
  ExerciseMetricDisplayMetadataSystem,
  ExerciseMetricDisplayMetadata,
};

export enum ExerciseType {
  Output = "Output",
  Custom = "Custom",
  Circuit = "Circuit",
}

/**
 * Classification of a set within a workout prescription or completion.
 * `null` where not applicable (e.g. circuits).
 */
export const TaskPrescriptionSet = {
  WarmUp: "WarmUp",
  Working: "Working",
} as const;

export type TaskPrescriptionSetType = (typeof TaskPrescriptionSet)[keyof typeof TaskPrescriptionSet];

export type Exercise = OutputExercise | CustomExercise;

// Processor type for exercise categorization
export type ProcessorType = string | null;
